<div class="menu-indice"><a routerLink="../../../{{ruta_regreso}}/{{a_tipo}}/{{c_constancia}}">Volver a Listado de {{x_tipo}}</a> / {{x_titulo}} </div>

  <mdb-card style="background-color: rgb(237, 241, 244)">
        <mdb-card-body>
          <div style="text-align: center; align-items: center; width: 100%; ">
            <div class="interno" style="width: 800px; height: 620px;">
              <iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
            </div>
          </div>
          <br>
          <div class="justify-content-center" style="text-align: center;">
            <button mdbBtn type="button" routerLink="../../../{{ruta_regreso}}/{{a_tipo}}/{{c_constancia}}"  size="md" class="btn btn-blue btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="arrow-left" class="mr-2"></mdb-icon>REGRESAR A LISTADO</button>
                &nbsp;  &nbsp;  &nbsp; &nbsp;  &nbsp;
            <button mdbBtn type="button" (click)="onDescargarArchivo()"  size="md" class="btn btn-teal btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="download" class="mr-2"></mdb-icon>DESCARGAR</button>
          </div>
        </mdb-card-body>
  </mdb-card>
